import React from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';

import { 
  FIELD_AREA_PAGE_STATUS,
  DRAWING_MODES
} from '../utilities/constants';
import { 
  Confirmation,
  Information
} from '../components/modals/common/';
import * as pages from '../components/pageComponents';
import { SelectBox } from '../components/select/SelectBox';
import Tippy from '../components/ReactTippy';
import { FieldSettings } from './FieldSettings';
import { InOutFieldAreas } from './InOutFieldAreas';
import styles from '../styles/componentStyle/inOutFieldAreas/InOutFieldAreas.scss';
import { DIALOG_STATUS } from '../utilities/constants';
import _urlParamManager from '../utilities/urlParamManager';
import EventManager, { EventType } from '../utilities/EventManager';
import Scroller from '../components/Scroller';
import GoogleMapComponent from '../components/gmap/googleMapComponent';
import { messageUtility } from '../utilities/messageUtility';
import { parseGeoJSONToCoordinates } from '../utilities/geoJsonUtil';
import { InOutDashboardApi } from '../services/inOutDashboard/InOutDashboardApi';
import { FieldSettingsApi } from '../services/fieldSettings/FieldSettingsApi';
import FieldSettingsService from '../services/fieldSettings/FieldSettingsService';
import { InOutFieldAreasApi } from '../services/InOutFieldAreas/InOutFieldAreasApi';
import InOutFieldAreasService from '../services/InOutFieldAreas/InOutFieldAreasService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { isNullOrEmpty, getiOSVersion } from '../utilities/stringUtil';

export class InOutFieldAreaForm extends React.Component {
  constructor(props) {
    super(props);

    this.pages = _.merge(pages, pages.setting);

    this.state = {
      isLoading: true,
      showLocationInfoFlg: 0,
      initialLoading: true,
      fieldId: SessionStorageService.getFieldId(),
      visibleDialogName: null,
      searchString: '',
      postalCode: '',
      isError: false,
      drawingMode: DRAWING_MODES.circle.valueName,
      area: {
        name: '',
        latitude: null,
        longitude: null,
        radius: null,
        polygon_coordinates: null,
        use_location_info_flg: 1,
      },
      informationModal: {
        title: null,
        message: null,
        buttonText: null,
        multilineText: false,
      }
    }

    if(props.pageStatus.ID===FIELD_AREA_PAGE_STATUS.EDIT.ID){
      this.state.area = {...props.area};
    }    
    this.searchInputRef = React.createRef();
    this.mapInstance = null;

    _urlParamManager.setDelegate(urlparam => {
      if (
        urlparam[this.props.vw - 1] &&
        (
          (
            props.pageStatus.ID === FIELD_AREA_PAGE_STATUS.EDIT.ID 
            && urlparam[this.props.vw - 1].split(':')[0] != 'InOutFieldAreaEdit'
          ) || (
            props.pageStatus.ID === FIELD_AREA_PAGE_STATUS.NEW.ID 
            && urlparam[this.props.vw - 1].split(':')[0] != 'InOutFieldAreaNew'
          )
        )
      ) {
        this.props.loadPage(this.pages[urlparam[this.props.vw - 1].split(':')[0]]);
        setTimeout(() => {
          EventManager.trigger(EventType.LAYOUT_UPDATE, {});
        }, 1);
      }
    });
  }

  componentDidMount() {
    let state = _.cloneDeep(this.state);

    if (isNullOrEmpty(state.fieldId)) {
      state.isShowNotExistFieldIdDialog = true;
      this.setState(state);
      return;
    }

    // アプリ利用フラグの確認のため、現場設定情報取得APIを呼び出す
    FieldSettingsApi.fetchCheckInOutSettings(state.fieldId)
      .then(response => {
        if (response.result) {
          const settings = FieldSettingsService.parseFetchCheckInOutSettingsResponseData(
            response.data
          );  

          // アプリ利用フラグが未設定の場合、現場設定に戻る
          if(!settings.use_worker_entrance_app_flg) {
            InOutFieldAreasService.handleLoadPage(FieldSettings, 'FieldSettings', this.props);
          }

          this.setState({ showLocationInfoFlg: settings.show_location_info_flg });

          // アプリ利用フラグが設定済みの場合、さらにリクエストする
          // エリア編集画面の場合、エリア情報取得APIを呼び出す
          if(this.props.pageStatus.ID===FIELD_AREA_PAGE_STATUS.EDIT.ID){
            this.setState({ isLoading: true });

            InOutFieldAreasApi.fetchInOutFieldArea(state.fieldId, state.area)
              .then(_response => {
                if (_response.result) {
                  this.setState(prevState => ({
                    ...prevState,
                    drawingMode: !_.isNull(_response.data.entities.check_in_out_field_area.polygon_coordinates) ? DRAWING_MODES.polygon.valueName : DRAWING_MODES.circle.valueName,
                    area: {
                      ..._response.data.entities.check_in_out_field_area,
                      latitude: _response.data.entities.check_in_out_field_area.latitude,
                      longitude: _response.data.entities.check_in_out_field_area.longitude,
                      radius: _response.data.entities.check_in_out_field_area.radius,
                      polygon_coordinates: parseGeoJSONToCoordinates(_response.data.entities.check_in_out_field_area.polygon_coordinates),
                      use_location_info_flg: _response.data.entities.check_in_out_field_area.use_location_info_flg
                    },
                    initialLoading: false
                  }));
                } else {   
                  let _state = _.cloneDeep(this.state);          
                  _state = InOutFieldAreasService.showErrorMessageDialog(_state, _response, DIALOG_STATUS.fieldAreasFetchFailed.id);
                  this.setState(_state);
                }
              })
              .catch(error => {
                let _state = _.cloneDeep(this.state);      
                _state = InOutFieldAreasService.showErrorMessageDialog(_state, error, DIALOG_STATUS.fieldAreasFetchFailed.id);
                this.setState(_state);
              })
              .finally(() => {
                this.setState({ isLoading: false });
              });            
          } else {
            // エリア追加画面の場合、郵便番号を取得するために、現場情報取得APIを呼び出す
            this.setState({ isLoading: true }, () => {
              InOutDashboardApi.fetchFieldInfo(state.fieldId)
                .then(_response => {
                  if (_response.result) {
                    this.setState(prevState => ({
                      ...prevState,
                      postalCode: _response.data.entities.field.postal_code,
                      initialLoading: false
                    }));
                  } else {            
                    let _state = _.cloneDeep(this.state);          
                    _state = InOutFieldAreasService.showErrorMessageDialog(_state, _response);
                    this.setState(_state);
                  }
                })
                .catch(error => {
                  let _state = _.cloneDeep(this.state);      
                  _state = InOutFieldAreasService.showErrorMessageDialog(_state, error);
                  this.setState(_state);
                })
                .finally(() => {
                  this.setState({ isLoading: false });
                });
            });
          }
        } else {
          InOutFieldAreasService.handleLoadPage(FieldSettings, 'FieldSettings', this.props);
        }
      })
      .catch(() => {
        InOutFieldAreasService.handleLoadPage(FieldSettings, 'FieldSettings', this.props);
      })
  }

  handleAreaEditing = () => {
    let state = _.cloneDeep(this.state);
    if (state.isLoading) {
      return;
    }

    if(!state.area.name.trim()) {
      this.setState({ isError: true });
      return;
    }

    if(state.drawingMode === DRAWING_MODES.circle.valueName && (!state.area.latitude || !state.area.longitude || !state.area.radius)){
      state = InOutFieldAreasService.showErrorMessageDialog(state, { message: data.no_area });
      this.setState(state);
      return;
    }

    if(state.drawingMode === DRAWING_MODES.polygon.valueName){
      if (state.area.use_location_info_flg) {
        if (isNullOrEmpty(state.area.polygon_coordinates) || state.area.polygon_coordinates.length < 3) {
          state = InOutFieldAreasService.showErrorMessageDialog(state, { message: data.np_polygon });
          this.setState(state);
          return;
        }
      } else {
        if (isNullOrEmpty(state.area.polygon_coordinates) || state.area.polygon_coordinates.length < 3) {
          this.setState({
            drawingMode: DRAWING_MODES.circle.valueName,
            area: {              
              ...this.state.area,
              polygon_coordinates: null
            }
          },
          () => {
            this.editAreaApiCall();
          });

          return;
        }
      }
    }

    this.editAreaApiCall();
  }

  editAreaApiCall = () => {
    this.setState({ isLoading: true }, () => {
      InOutFieldAreasApi.editInOutFieldArea(this.state.fieldId, this.state.area)
      .then(response => {
        if (response.result) {
          this.setState({
            dialogStatus: DIALOG_STATUS.updateSuccessDialogEnabled.id,
          });
        } else {            
          let _state = _.cloneDeep(this.state);          
          _state = InOutFieldAreasService.showErrorMessageDialog(_state, response);
          this.setState(_state);
        }
      })
      .catch(error => {
        let _state = _.cloneDeep(this.state);      
        _state = InOutFieldAreasService.showErrorMessageDialog(_state, error);
        this.setState(_state);
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
    });
  }

  handleAreaCreation = () => {
    let state = _.cloneDeep(this.state);
    if (state.isLoading) {
      return;
    }

    if(!state.area.name.trim()) {
      this.setState({ isError: true });
      return;
    }

    if(state.drawingMode === DRAWING_MODES.circle.valueName && (!state.area.latitude || !state.area.longitude || !state.area.radius)){
      state = InOutFieldAreasService.showErrorMessageDialog(state, { message: data.no_area });
      this.setState(state);
      return;
    }

    if(state.drawingMode === DRAWING_MODES.polygon.valueName){
      if (state.area.use_location_info_flg) {
        if (isNullOrEmpty(state.area.polygon_coordinates) || state.area.polygon_coordinates.length < 3) {
          state = InOutFieldAreasService.showErrorMessageDialog(state, { message: data.np_polygon });
          this.setState(state);
          return;
        }
      } else {
        if (isNullOrEmpty(state.area.polygon_coordinates) || state.area.polygon_coordinates.length < 3) {
          this.setState({
            drawingMode: DRAWING_MODES.circle.valueName
          },
          () => {
            this.createAreaApiCall();
          });

          return;
        }
      }
    }

    this.createAreaApiCall();
  }

  createAreaApiCall = () => {
    this.setState({ isLoading: true }, () => {
      InOutFieldAreasApi.createInOutFieldArea(this.state.fieldId, this.state.area)
      .then(response => {
        if (response.result) {
          this.setState({
            dialogStatus: DIALOG_STATUS.updateSuccessDialogEnabled.id,
          });
        } else {            
          let _state = _.cloneDeep(this.state);          
          _state = InOutFieldAreasService.showErrorMessageDialog(_state, response);
          this.setState(_state);
        }
      })
      .catch(error => {
        let _state = _.cloneDeep(this.state);      
        _state = InOutFieldAreasService.showErrorMessageDialog(_state, error);
        this.setState(_state);
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
    });
  }

  closeDialog = () => {
    let state = { ...this.state };
    state.dialogStatus = DIALOG_STATUS.disabled.id;
    state.informationModal.title = null;
    state.informationModal.message = null;
    state.informationModal.buttonText = null;
    this.setState(state);
  };

  handleVisibleDialog = (visibleDialogName) => {
    this.setState({ visibleDialogName });
  };

  handleMapLoad = (mapInstance) => {
    this.mapInstance = mapInstance;
    this.initAutocomplete(mapInstance);
  };

  initAutocomplete = (map) => {
    if (!map || !this.searchInputRef.current) return;
    const autocomplete = new window.google.maps.places.Autocomplete(this.searchInputRef.current);
    autocomplete.bindTo('bounds', map);
    autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);
    autocomplete.setComponentRestrictions({country: [ "jp"],});

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      let state = _.cloneDeep(this.state);
      if (!place.geometry) {
        state.dialogStatus = DIALOG_STATUS.gMapSearchNoPlace.id;
        this.setState(state);
        return;
      }

      if (place.geometry.viewport) {
        map.fitBounds(place.geometry.viewport);
      } else {
        map.setCenter(place.geometry.location);
        map.setZoom(15);
      }
      this.setState({ searchString: this.searchInputRef.current.value });
    });
  };

  handleCircleUpdate = (newCoordinates, newRadius) => {
    this.setState({
      area: {
        ...this.state.area,
        latitude: newCoordinates.lat,
        longitude: newCoordinates.lng,
        radius: newRadius,
        polygon_coordinates: null
      }
    });
  };

  handlePolygonUpdate = (newPolygonCoordinates) => {
    this.setState({
      area: {
        ...this.state.area,
        polygon_coordinates: newPolygonCoordinates
      }
    });
  };

  toggleUseLocationInfoFlg = () => {
    this.handleSearchClear();
    this.setState(prevState => ({
      area: {
        ...prevState.area,
        use_location_info_flg: prevState.area.use_location_info_flg ? 0 : 1
      }
    }));
  };

  selectDrawingMode = (drawingMode) => {
    this.setState({ drawingMode });
  };

  inputSearchString = event => {
    this.setState({ searchString: event.target.value });
  };

  handleAreaSearch = () => {
    let state = _.cloneDeep(this.state);
    if (!this.mapInstance || !state.searchString) return;

    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ address: this.state.searchString }, (results, status) => {
      if (status === 'OK' && results[0]) {
        const location = results[0].geometry.location;
        this.mapInstance.setCenter(location);
        this.mapInstance.setZoom(15); 
        this.setState({
          area: {
            ...this.state.area,
            latitude: location.lat(),
            longitude: location.lng(),
          }
        });
      } else {
        state.dialogStatus = DIALOG_STATUS.gMapSearchNoPlace.id;
        this.setState(state);
      }
    });
  };

  inputAreaName = event => {
    this.setState(prevState => ({
      area: {
        ...prevState.area,
        name: event.target.value
      }
    }));
  };

  inputAreaNameCheck = event => {
    if(!event.target.value.trim()) {
      this.setState({ isError: true });
    } else {
      this.setState({ isError: false });
    }
  };

  handleSearchClear = () => {
    this.setState({ searchString: '' });
  };

  handleCloseEdit = () => {
    if(this.isIos16Plus()) {
      this.setState({ dialogStatus: DIALOG_STATUS.cancelEditDialogEnabled.id });
    } else {
      InOutFieldAreasService.handleLoadPage(InOutFieldAreas, 'InOutFieldAreas', this.props);
    }
  };

  isIos16Plus = () => {
    return getiOSVersion() > 15 || isNullOrEmpty(getiOSVersion()) ? true : false;
  };

  render() {
    return(
      <React.Fragment>
        <div id='main' className='main field-area-form'>
          <Helmet title={data.title} />
          <div className={`${styles.header} main__header`}>
            <button
              className='btn-text--sm'
              onClick={this.handleCloseEdit}>
              <i className='i-back--blue i-2x vertical-middle' />
              {data.field_areas_page}
            </button>
            <h1>{data.title}</h1>
          </div>

          <Scroller>
            <div className={`${styles.form} main__body ${!this.isIos16Plus() ? "disabled" : ""}`}>
              <div className='setting-header'>
                <div className='field-area-form-main__header'>
                  <div className='setting-header__item'>
                    <button
                      className='btn--sub'
                      type='submit'
                      onClick={(event) => {
                        event.target.blur();
                        this.handleCloseEdit();
                      }}
                    >
                      {
                        this.props.pageStatus.ID === FIELD_AREA_PAGE_STATUS.EDIT.ID 
                          ? data.button.cancel_edit
                          : data.button.cancel_create
                      }
                    </button>
                    <button
                      className={`${this.isIos16Plus() ? "btn--effective" : "btn--disabled"}`}
                      type='submit'
                      disabled={!this.isIos16Plus()}
                      onClick={(event) => {
                        event.target.blur();
                        if (this.props.pageStatus.ID === FIELD_AREA_PAGE_STATUS.EDIT.ID) {
                          this.handleAreaEditing();
                        } else {
                          this.handleAreaCreation();
                        }
                      }}
                    >
                      {
                        this.props.pageStatus.ID === FIELD_AREA_PAGE_STATUS.EDIT.ID 
                        ? data.button.edit
                        : data.button.create
                      }
                    </button>
                    {(!!this.state.showLocationInfoFlg && (
                      <label className="checkbox use_location_info_flg-label">
                        <input 
                        id='use-location-info-flg'
                        type='checkbox'
                        checked={this.state.area.use_location_info_flg}
                        disabled={!this.isIos16Plus()}
                        onChange={() =>
                          this.toggleUseLocationInfoFlg()
                        } 
                        />
                        <i className={`${this.isIos16Plus() ? "i-square" : "i-square-disabled"} i-3x`}></i>
                        {data.area_status}
                      </label>
                    ))}
                    {(!!this.state.showLocationInfoFlg && (
                      <React.Fragment>
                        <SelectBox
                          name='form_type_select'
                          value={
                            this.state.drawingMode
                          }
                          isPlaceholderHidden={true}
                          items={DRAWING_MODES}
                          label={data.form_type_label}
                          valueName='valueName'
                          keyName='id'
                          itemName='name'
                          disabled={!this.state.area.use_location_info_flg || !this.isIos16Plus()}
                          onChange={event => {
                            this.selectDrawingMode(event.target.value)
                          }}
                        />
                        <Tippy
                          duration={10}
                          distance={24}
                          arrow='true'
                          arrowType='sharp'
                          delay={[100, 100]}
                          placement='top'
                          followCursor={true}
                          disable={!this.state.area.use_location_info_flg || !this.isIos16Plus()}
                          html={<div className='permission-tooltip'>{this.state.drawingMode === DRAWING_MODES.polygon.valueName ? data.tip_polygon : data.tip_circle}</div>}
                        >
                          <i className={`i-question--tooltip i-question--grey ${!this.state.area.use_location_info_flg || !this.isIos16Plus() ? 'disabled' : ''}`} />
                        </Tippy>
                      </React.Fragment>
                    ))}
                    <span className='alert-text'>
                      {!this.state.isError
                        ? null
                        : messageUtility.getMessage('E-000-014')}
                    </span>
                  </div>
                </div>
              </div>  

               <div className={`${styles.table} field-area-form-main__body`}>
                <div className={`form-list form-list-default form-list-default--space ${!this.isIos16Plus() ? "os-disabled" : ""}`}>
                  <div className='input-container'>
                    <div className='form-list__item area-name'>
                      <label className='forst-list__label'>
                        {data.area_name}
                        <span className='RequireIcon'>
                          必須
                        </span>
                      </label>     
                      <div className={`form-list__element ${this.state.isError && 'form-list__element--error'}`}>        
                        <input
                          name="areaName"
                          type="text"
                          maxLength="60"
                          minLength="1"
                          required
                          placeholder={data.area_name_placeholder}
                          value={this.state.area.name}
                          disabled={!this.isIos16Plus()}
                          onInput={event => {
                            this.inputAreaName(event);
                          }}
                          onBlur={event => {
                            this.inputAreaNameCheck(event);
                          }}
                        />
                        <div className={`form-list__alert ${this.state.isError && 'show'}`}>
                          {messageUtility.getMessage('E-000-024', 60)}
                        </div>
                      </div>       
                    </div>
                    <div className='search-box'>
                      <i className='i-search i-1x' />
                      <input
                        ref={this.searchInputRef}
                        name='searchForm'
                        type='text'
                        disabled={!this.state.area.use_location_info_flg || !this.isIos16Plus()}
                        placeholder={data.search_placeholder}
                        value={this.state.searchString}
                        onInput={event => {
                          this.inputSearchString(event);
                        }}
                        onKeyUp={event => {
                          if (event.key === 'Enter') this.inputSearchString(event);
                        }}
                      />
                      <button
                        className={`btn--stay${this.state.area.use_location_info_flg && this.isIos16Plus() ? '' : ' btn--disabled'}`}
                        disabled={!this.state.area.use_location_info_flg || !this.isIos16Plus()}
                        type='submit'
                        onClick={this.handleAreaSearch}
                      >
                        {data.button.search}
                      </button>
                      <button
                        className={`btn${this.state.area.use_location_info_flg && this.isIos16Plus() ? '' : ' btn--disabled'}`}
                        disabled={!this.state.area.use_location_info_flg || !this.isIos16Plus()}
                        type='submit'
                        onClick={this.handleSearchClear}
                      >
                        {data.button.clear}
                      </button>
                    </div>
                  </div>
                  {this.isIos16Plus() ? (!this.state.initialLoading && (
                    <GoogleMapComponent
                      latitude={this.state.area.latitude}
                      longitude={this.state.area.longitude}
                      initialRadius={this.state.area.radius}
                      polygonCoordinates={this.state.area.polygon_coordinates}
                      postalCode={this.state.postalCode}
                      drawingMode={this.state.drawingMode}
                      onCircleChange={this.handleCircleUpdate}
                      onPolygonChange={this.handlePolygonUpdate}
                      onMapLoad={this.handleMapLoad}
                      disabled={!this.state.area.use_location_info_flg}
                    />
                  )) : (
                    <div className="os-disabled-text">{data.unsupported_os_text}</div>
                  )}
                </div>
              </div>
            </div>
          </Scroller>
        </div>
        <Information
          visible={
            this.state.dialogStatus ===
            DIALOG_STATUS.updateSuccessDialogEnabled.id
          }
          title={
            this.props.pageStatus.ID === FIELD_AREA_PAGE_STATUS.EDIT.ID 
              ? data.confirmation.area_updated_title 
              : data.confirmation.area_created_title
          }
          message={
            this.props.pageStatus.ID === FIELD_AREA_PAGE_STATUS.EDIT.ID 
              ? data.confirmation.area_updated_text 
              : data.confirmation.area_created_text
          }
          buttonText={data.button.close}
          onClose={() => InOutFieldAreasService.handleLoadPage(InOutFieldAreas, 'InOutFieldAreas', this.props)}
          multilineText={true}
        />      
        <Confirmation
          visible={
            this.state.dialogStatus === DIALOG_STATUS.cancelEditDialogEnabled.id
          }
          title={messageUtility.getMessage('I-000-025')}
          confirmButtonText={messageUtility.getMessage('I-000-025')}
          cancelButtonText={messageUtility.getMessage('I-000-008')}
          message={messageUtility.getMessage('I-000-050')}
          isNegative
          onConfirm={() => InOutFieldAreasService.handleLoadPage(InOutFieldAreas, 'InOutFieldAreas', this.props)}
          onCancel={() => this.closeDialog()}
        />
        <Information
          rootClassName={
            this.state.informationModal.message &&
            this.state.informationModal.message.length > 28
              ? `wide-dialog-md`
              : ''
          }
          visible={
            this.state.dialogStatus === DIALOG_STATUS.otherErrorDialogEnabled.id
          }
          title={this.state.informationModal.title}
          message={this.state.informationModal.message}
          buttonText={this.state.informationModal.buttonText}
          onClose={() => this.closeDialog()}
        />
        <Information
          rootClassName={
            this.state.informationModal.message &&
            this.state.informationModal.message.length > 28
              ? `wide-dialog-md`
              : ''
          }
          visible={
            this.state.dialogStatus === DIALOG_STATUS.fieldAreasFetchFailed.id
          }
          title={this.state.informationModal.title}
          message={this.state.informationModal.message}
          buttonText={this.state.informationModal.buttonText}
          onClose={() => InOutFieldAreasService.handleLoadPage(InOutFieldAreas, 'InOutFieldAreas', this.props)}
        />
        <Information
          visible={
            this.state.dialogStatus === DIALOG_STATUS.gMapSearchNoPlace.id
          }
          title={data.no_place_title}
          message={data.no_place}
          buttonText={data.button.close}
          onClose={() => this.closeDialog()}
        />
      </React.Fragment>
    );
  }
}

/**
 * 新規作成フォーム
 */
export class InOutFieldAreaNew extends React.Component {
  render() {
    return (
      <InOutFieldAreaForm
        {...this.props}
        pageStatus={FIELD_AREA_PAGE_STATUS.NEW}
      />
    );
  }
}

/**
 * 編集フォーム
 */
export class InOutFieldAreaEdit extends React.Component {
  render() {
    const areaInfo = { id: _.split(_urlParamManager.urlparam[0], ':')[1] };

    return (
      <InOutFieldAreaForm
        {...this.props}
        pageStatus={FIELD_AREA_PAGE_STATUS.EDIT}
        area={areaInfo}
      />
    );
  }
}

// 定数
const data = {
  title: "エリア編集",
  field_areas_page: "エリア一覧",
  area_name: "エリア名",
  area_status: "GPS判定",
  search_placeholder: "アドレスを入力",
  area_name_placeholder: "エリア名を入力",
  no_area: "エリアを選択は必須です。",
  no_place: "検索キーワードに間違いがないかご確認ください。",
  no_place_title: "検索キーワードの場所が見つかりません",
  np_polygon: "ポリゴンの頂点を最低3つ設定してください。",
  button: {
    edit: "更新",
    create: "登録",
    clear: "クリア",
    search: "検索",
    cancel_edit: '編集をやめる',
    cancel_create: '登録をやめる',
    back: '戻る',
    close: '閉じる'
  },
  confirmation: {
    area_updated_title: 'エリア更新完了',
    area_updated_text: 'エリアの更新が完了しました。',
    area_created_title: 'エリア登録完了',
    area_created_text: 'エリアの登録が完了しました。',
  },
  form_type_label: "形式",
  form_types: ["円", "ポリゴン"],
  tip_circle: "・地図をクリックし円の中心点を作成し、エリアを囲ってください\n・円に表示された点を選択したままドラッグすることで円のサイズを変更できます\n・円を選択したままドラッグすることでエリアの位置を移動できます",
  tip_polygon: "・地図をクリックし点をつけてポリゴンを作成し、エリアを囲ってください\n・作成した点を選択したままドラッグすることで移動できます\n・点を右クリックすることで削除できます（iPadの場合は点を長押しで削除）\n・作成した点と点の間に色の薄い点が自動でできますが、実点に変更して角を追加できます\n・点を移動、もしくは間に点を追加した場合、直前の編集を１操作分だけ取り消せます\n・ポリゴンを選択したままドラッグすることでエリアの位置を移動できます\n・左下の「ポリゴンをクリア」ボタンを押下しポリゴンを削除できます",
  unsupported_os_text: "お使いのiOSバージョンはエリアの地図表示に対応していません。\niOS16以上のiPad、またはPCからアクセスし操作を行ってください。",
};


// WEBPACK FOOTER //
// ./src/pages/InOutFieldAreaForm.jsx